import { Capacitor } from '@capacitor/core';
import { iosMediaAdapter } from './iosMediaAdapter';
import type { MediaAdapter } from './mediaContract';
import { webMediaAdapter } from './webMediaAdapter';

// Single selection point for the media lane: native app → iOS adapter, everything else → the
// file-input adapter. Tests inject a fake adapter through setMediaAdapterForTests.
let override: MediaAdapter | null = null;

export function getMediaAdapter(): MediaAdapter {
  if (override) return override;
  return Capacitor.isNativePlatform() ? iosMediaAdapter : webMediaAdapter;
}

export function setMediaAdapterForTests(adapter: MediaAdapter | null): void {
  override = adapter;
}
